import { FC, Fragment } from "react";
import { clsx } from "clsx";
import { Tooltip } from "../../design-system/components/Tooltip";
import { SvgIcon } from "./SvgIcon";
import classes from "./CategoryPath.module.less";

/** How a category path (root first) reads on screen, e.g. "IT › SaaS". */
export const categoryLabel = (path: string[]): string => path.join(" › ");

export interface CategoryPathProps {
    path?: string[];
}

/**
 * A project's category, read-only: the branch (every level but the last,
 * separated by chevrons) on a small grey line, and the category's own name
 * below it in larger text. A subtle placeholder when unset, centered in a box
 * as tall as a two-line path so rows line up either way.
 */
export const CategoryPath: FC<CategoryPathProps> = ({ path }) => {
    if (!path?.length) {
        return (
            <div className={clsx(classes.category, classes["category--unset"])}>
                <div className={clsx(classes.leaf, classes.unset)}>Not categorized</div>
            </div>
        );
    }
    const branch = path.slice(0, -1);
    return (
        <Tooltip title={categoryLabel(path)} overlayStyle={{ maxWidth: "none" }}>
            <div className={classes.category}>
                {branch.length > 0 && (
                    <div className={classes.branch}>
                        {branch.map((label, i) => (
                            <Fragment key={i}>
                                {i > 0 && (
                                    <SvgIcon name="right" size={8} className={classes.chevron} />
                                )}
                                {label}
                            </Fragment>
                        ))}
                    </div>
                )}
                <div className={classes.leaf}>{path[path.length - 1]}</div>
            </div>
        </Tooltip>
    );
};
